import * as React from 'react'
import * as Redux from 'redux'
import * as Tgcc from '../tgccGlobal'
import Radium, { StyleRoot } from 'radium';
import {connect} from 'react-redux'
import {CSSProperties} from 'react'
import {browserHistory} from 'react-router'
import {CampusFileCard} from './CampusFileCard'
import * as Request from '../tgccRequest'

const validUploadExts: string = ".jpg,.png,.pdf,.psd,.ai,.tif,.gif,.svg";

const wrapperStyle: CSSProperties = {
    fontFamily: 'CenturyGothic',
    textTransform: 'uppercase',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    alignSelf: 'center',
    backgroundColor: 'white',
    borderRadius:'20px',
    width:'300px'
}

const containerStyle: CSSProperties = {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignSelf: 'center',
    backgroundColor: Tgcc.Styles.cardBackground,
    overflowX: 'auto',
    borderRadius:'20px',
    width:'304px',
    '@media (max-width:414px)': {
        width:'88%'
    },
}

const titleStyle: CSSProperties = {
    textAlign: 'center',
    color:'#616060',
    padding:'5px',
    fontFamily:'Lulo',
    fontSize:'14px',
    '@media (max-width:320px)': {
        fontSize:'17px'
    }
}

const filenameStyle: CSSProperties = {
    display: 'flex',
    lineHeight: '30px',
    height: '30px',
    fontSize: '12px',
    paddingLeft: '2px',
    paddingRight: '2px',
    overflow: 'hidden',
    width: '275px',
    margin: '5px',
    textAlign: 'center',
    backgroundColor: Tgcc.Styles.inputBackground,
    color: Tgcc.Styles.darkTextColor
}

// this styling hides the default input for file
const inputFileStyle: CSSProperties = {
    width: '0.1px',
    height: '0.1ex',
    opacity: 0,
    overflow: 'hidden',
    position: 'absolute',
    zIndex: -1
}

const bulletStyle: CSSProperties = {
    height: '5px',
    margin: '5px'
}

const uploadBoxStyle: CSSProperties = {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center'
}
const uploadGrpStyle: CSSProperties = {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    marginTop:'15px'
}
const fileGrpStyle: CSSProperties = {
    display: 'flex',
    flexWrap: 'wrap',
    flexDirection: 'row',
    padding: '25px',
    justifyContent: 'space-around',
    alignItems: 'center'
}
const uploadNotes: CSSProperties = {
    textAlign:'center',
    fontSize:'14px',
    fontFamily:'BarlowLight',
    color:'#616060'
}

class Props extends Tgcc.BaseProps{
    proofId: string;
    title: string;
    uploadedFiles: any;
    addUpload?: (filename: string, fileurl:string) => void;
    removeUpload?: (fileUrl: string) => void;
    backAction?: () => void;
    setProofId?: (id: string) => void;
    width?:string;
}



const browseBtnStyle: CSSProperties = {
    border: '1px solid transparent',
    backgroundColor: '#3A54B4',
    height: '30px',
    lineHeight: '30px',
    fontSize: '15px',
    padding: '0 25px',
    textAlign: 'center',
    textTransform: 'uppercase',
    color: 'white',
    alignSelf: 'center',
    cursor: 'pointer',
    margin: '0',
    fontFamily:'Lulo'
};

const uploadBtnStyle: CSSProperties = {
    border: '1px solid black',
    height: '30px',
    lineHeight: '30px',
    fontSize: '15px',
    padding: '0 25px',
    textAlign: 'center',
    textTransform: 'uppercase',
    color: 'black',
    alignSelf: 'center',
    cursor: 'pointer',
    margin: '28 5px 5px 5px',
    opacity:1,
    fontFamily:'Lulo',
    ':hover': {
        backgroundColor:'rgba(123, 115, 111, 1)',
        color:'white'
    }
}

const disabledBtnStyle = Object.assign({}, uploadBtnStyle, {opacity: 0.5});

const horzLines : CSSProperties = {
    width:'60px',
    height:'5px',
    borderBottom:'1px solid #E9E6E6',
    marginTop:'-3px'
}
class _NewCampusUploadFiles extends React.Component<Props, any>{
    state: any = {
        error: null,
        filename: '',
        fileToUpload: null,
        isWaiting: false,
        uploadedFiles: {}
    };

    componentWillMount() {
        // seed our local uploadedFiles state from redux
        this.setState({
          uploadedFiles: this.props.state.ActiveProof.uploadedFiles || {}
        });
      
        // if we don’t yet have a proofId, call the promise API
        if (!this.props.proofId && this.props.setProofId) {
          Request
            .initProof()                            // no args now
            .then(proofId => {
              this.props.setProofId(proofId);
            })
            .catch(err => {
              this.failedInit(err);
            });
        }
      
        // respect any width override
        if (this.props.width) {
          wrapperStyle.width   = this.props.width;
          containerStyle.width = this.props.width;
        }
      }
      

    failedInit = (err: any) => {
        console.log('Failed to init proof id:', err);
    }

    handleTextChange = (evt) => {
        this.setState({fileText: evt.target.value});
    }

    handleFileInputChange = (evt: React.FormEvent<HTMLInputElement>) => {
        try{
            var file = evt.currentTarget.files[0];
            this.setState({filename: file.name, fileToUpload: file, error: null});
        } catch(err){
            console.log("error browsing for file to upload: ", err)
        }
    }

    handleFileUpload = (evt: React.SyntheticEvent<HTMLDivElement>) => {
        var filename = this.state.filename;
        if(!filename)
            return this.setState({error: "File name cannot be empty", isWaiting: false});

        var file = this.state.fileToUpload as File;
        if(!file)
            return this.setState({error: "Error accessing file to upload", isWaiting: false});
        
        var proofId = this.props.proofId;
        this.setState({isWaiting: true, error: null});
        Request.uploadFile(proofId, file, this.uploadSuccessful, this.uploadFailed);
    }

    uploadSuccessful = (fileUrl: string) => {
        var newfile = {};
        this.addUpload(this.state.filename, fileUrl);
        newfile[this.state.filename] = fileUrl;
        var newFiles = Object.assign({}, this.state.uploadedFiles, newfile);
        this.setState({error: 'Successful upload', uploadedFiles: newFiles, filename: '', isWaiting: false})
    }

    uploadFailed = (err: string) =>{
        this.setState({error: err, isWaiting: false});
    }

    fileInputName = "FileUploaderInput";
    browseFiles = (evt: React.SyntheticEvent<HTMLDivElement>) => {
        var fInput = document.getElementById(this.fileInputName);
        fInput.click();
    }

    backToProof = () => {
        browserHistory.goBack();
    }

    addUpload = (name: string, url: string) => {
        if(this.props.addUpload && name && url)
            this.props.addUpload(name, url);
    }
   
    removeUpload = (fileUrl: string) => {
        var files = this.state.uploadedFiles;
        var newfiles = {};
        Object.keys(files).map( (key) => {
            if(files[key] != fileUrl)
                newfiles[key] = files[key];
        });
        
        this.setState({uploadedFiles: newfiles, error: null});
        if(this.props.removeUpload && fileUrl)
            this.props.removeUpload(fileUrl);
    }


    getFileCards = () => {
        var files = this.state.uploadedFiles;
            {return Object.keys(files).map((key) => { 
                return <CampusFileCard 
                        key={key} 
                        filename={key} 
                        fileUrl={files[key]} 
                        removeItem={this.removeUpload}/>
            })
        }
    }

    render() {

        if(!this.props.proofId)
            return null;
            
        var uploadBtn = this.state.filename ?
            <div style={uploadBtnStyle} onClick={this.handleFileUpload}>Upload</div>
            : <div style={disabledBtnStyle} onClick={this.handleFileUpload}>Upload</div>
        if(this.state.isWaiting)
            uploadBtn = Tgcc.workingGif;

        var error = this.state.error ? <div style={Tgcc.Styles.error}>{this.state.error}</div> : null;
        var fileCards = this.getFileCards();
        return (
            <div style={wrapperStyle} className='campusImgUpload'>
                <div style={containerStyle}>
                    <div style={titleStyle}>{this.props.title}</div>
                    <div style={uploadNotes}>Select one file at a time to upload.</div>
                    <div style={uploadBoxStyle}>
                        <div style={filenameStyle}>{this.state.filename}</div>
                        <input id={this.fileInputName} type="file" accept={validUploadExts} style={inputFileStyle} onChange={this.handleFileInputChange} value={this.state.text} />
                        <div style={browseBtnStyle} className="hoverBorder" onClick={this.browseFiles}>Browse</div>
                    </div>
                        <div style={uploadNotes}>*Must click Upload to upload a file.</div>
                        {error}
                    <div style={uploadGrpStyle}>
                        <div style={horzLines}></div>
                        {uploadBtn}
                        <div style={horzLines}></div>
                    </div>
                    <div style={fileGrpStyle} >
                        {fileCards}
                    </div>
                </div>
            </div>
        )
    }
}

export var NewCampusUploadFiles = Radium(_NewCampusUploadFiles);